import { useContext } from 'react';

import { PagePanelContext } from '../contexts/PagePanelContext';

export const usePagePanelContext = () => useContext(PagePanelContext);
